import { useAcceptInvitationMutation } from "@graphql/auth/auth.g";
import { StytchTokenTypeEnum } from "@graphql/generated/graphql.g";
import debounce from "lodash/debounce";
import { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { toast } from "react-toastify";

import { Spinner } from "@design-system/Spinner/Spinner";

import { routes } from "@pages/routes";

import { setTenantSchemaTag } from "../../../sentry";

import classes from "./Invitation.module.css";

export const Invitation = () => {
  const [searchParams] = useSearchParams();
  const invitationMagicLinkTokenMutation = useAcceptInvitationMutation();
  const navigate = useNavigate();

  const handleInvitationMagicLinkToken = useCallback(async () => {
    try {
      if (
        invitationMagicLinkTokenMutation.isPending ||
        invitationMagicLinkTokenMutation.isSuccess
      )
        return;

      const token = searchParams.get("token");
      const stytchTokenType = searchParams
        .get("stytch_token_type")
        ?.toUpperCase() as StytchTokenTypeEnum;

      if (!token || !stytchTokenType) {
        navigate(routes.login.index.$path(), {
          viewTransition: true,
          replace: true,
        });
        return;
      }

      const data = await invitationMagicLinkTokenMutation.mutateAsync({
        token,
      });

      if (data.acceptInvitation?.organizationSlug) {
        setTenantSchemaTag(data.acceptInvitation.organizationSlug);
        navigate(routes.portal.dashboard.$path(), {
          viewTransition: true,
        });
      }
    } catch {
      toast.error("Error accepting invitation. Please try again.");

      navigate(routes.login.index.$path(), {
        viewTransition: true,
        replace: true,
      });
    }
  }, [navigate, searchParams, invitationMagicLinkTokenMutation]);

  const debouncedInvitationMagicLinkToken = useMemo(
    () => debounce(handleInvitationMagicLinkToken, 3000),
    [handleInvitationMagicLinkToken],
  );

  useEffect(() => {
    debouncedInvitationMagicLinkToken();
  }, [debouncedInvitationMagicLinkToken]);

  return (
    <div className={classes.container}>
      <Spinner size={32} />
    </div>
  );
};
